import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { exportCSV, printTable } from '../components/ExportButton';
import Spinner from '../components/Spinner';

function Card({ title, value, sub, color = '#1a3a5c' }) {
  return (
    <div style={{background:'white',border:'1px solid #dde4ec',borderRadius:8,padding:'12px 16px',flex:1,minWidth:160}}>
      <div style={{fontSize:11,color:'#888',marginBottom:4}}>{title}</div>
      <div style={{fontSize:18,fontWeight:'bold',color}}>{value}</div>
      {sub && <div style={{fontSize:11,color:'#aaa',marginTop:2}}>{sub}</div>}
    </div>
  );
}

const CURRENT_YEAR = new Date().getFullYear();
const LUNI = ['Ian','Feb','Mar','Apr','Mai','Iun','Iul','Aug','Sep','Oct','Nov','Dec'];

function fmt(val) {
  return parseFloat(val||0).toLocaleString('ro-RO', {minimumFractionDigits:2, maximumFractionDigits:2});
}

export default function Rapoarte() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [anDeLa, setAnDeLa] = useState(CURRENT_YEAR);
  const [anPanaLa, setAnPanaLa] = useState(CURRENT_YEAR);
  const [nrAuto, setNrAuto] = useState('');
  const [nruri, setNruri] = useState([]);
  const [years, setYears] = useState([CURRENT_YEAR]);

  // --- Acordeon "Cheltuieli lunare" - detaliu cronologic, grupat pe vehicul ---
  const [randDeschis, setRandDeschis] = useState({});   // { 'an-luna': true/false }
  const [detaliiLuna, setDetaliiLuna] = useState({});   // { 'an-luna': [...] sau undefined = in curs de incarcare }

  useEffect(() => {
    api.get('/api/auto/nruri').then(r => setNruri(r.data.map(x => x.nrInmatriculare)));
    // Anii disponibili pornesc de la prima inregistrare din baza de date, nu de la
    // o valoare hardcodata - relevant mai ales pentru clienti noi, cu istoric diferit.
    api.get('/api/rapoarte/an-minim').then(r => {
      const anMinim = r.data.anMinim || CURRENT_YEAR;
      const lista = [];
      for (let y = anMinim; y <= CURRENT_YEAR + 1; y++) lista.push(y);
      setYears(lista);
    }).catch(() => setYears([CURRENT_YEAR]));
  }, []);

  useEffect(() => { loadRaport(); setRandDeschis({}); setDetaliiLuna({}); }, [anDeLa, anPanaLa, nrAuto]);

  const loadRaport = () => {
    setLoading(true);
    const params = new URLSearchParams({ anDeLa, anPanaLa });
    if (nrAuto) params.append('nrAuto', nrAuto);
    api.get(`/api/rapoarte?${params}`).then(r => setData(r.data)).finally(() => setLoading(false));
  };

  const toggleLuna = (an, luna) => {
    const cheie = `${an}-${luna}`;
    setRandDeschis(prev => {
      const vaDeschide = !prev[cheie];
      if (vaDeschide && !detaliiLuna[cheie]) {
        const params = new URLSearchParams({ an, luna });
        if (nrAuto) params.append('nrAuto', nrAuto);
        api.get(`/api/rapoarte/detaliu-luna?${params}`)
          .then(r => setDetaliiLuna(d => ({ ...d, [cheie]: r.data })))
          .catch(() => setDetaliiLuna(d => ({ ...d, [cheie]: [] })));
      }
      return { ...prev, [cheie]: vaDeschide };
    });
  };

  const grupeazaPeVehicul = (linii) => {
    const grupuri = {};
    for (const r of linii) {
      const veh = r.nrAuto || '(fără vehicul)';
      if (!grupuri[veh]) grupuri[veh] = [];
      grupuri[veh].push(r);
    }
    return grupuri;
  };

  const exportLuna = (an, luna) => {
    const linii = detaliiLuna[`${an}-${luna}`] || [];
    exportCSV(linii, `cheltuieli_${LUNI[parseInt(luna) - 1] || luna}_${an}`);
  };
  const printLuna = (an, luna) => {
    const linii = detaliiLuna[`${an}-${luna}`] || [];
    printTable(`Cheltuieli ${LUNI[parseInt(luna) - 1] || luna} ${an}${nrAuto ? ' — ' + nrAuto : ''}`, linii);
  };

  return (
    <div style={{padding:16}}>
      {/* Filtre */}
      <div style={{display:'flex',gap:16,alignItems:'center',marginBottom:20,flexWrap:'wrap',
        background:'white',padding:'12px 16px',borderRadius:8,border:'1px solid #dde4ec'}}>
        <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
          <span style={{fontSize:12,fontWeight:'bold',color:'#555',whiteSpace:'nowrap'}}>Perioadă:</span>
          <select value={anDeLa} onChange={e=>setAnDeLa(e.target.value)}
            style={{padding:'5px 8px',fontSize:12,border:'1px solid #ccc',borderRadius:4,width:'auto'}}>
            {years.map(y=><option key={y}>{y}</option>)}
          </select>
          <span style={{color:'#888'}}>—</span>
          <select value={anPanaLa} onChange={e=>setAnPanaLa(e.target.value)}
            style={{padding:'5px 8px',fontSize:12,border:'1px solid #ccc',borderRadius:4,width:'auto'}}>
            {years.map(y=><option key={y}>{y}</option>)}
          </select>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
          <span style={{fontSize:12,fontWeight:'bold',color:'#555',whiteSpace:'nowrap'}}>Autovehicul:</span>
          <select value={nrAuto} onChange={e=>setNrAuto(e.target.value)}
            style={{padding:'5px 8px',fontSize:12,border:'1px solid #ccc',borderRadius:4,width:'auto'}}>
            <option value="">Toate</option>
            {nruri.map(n=><option key={n}>{n}</option>)}
          </select>
        </div>
      </div>

      {loading ? <Spinner /> : data && <>
        {/* Sumar */}
        <div style={{marginBottom:20}}>
          <div style={{fontWeight:'bold',color:'#1a3a5c',marginBottom:10,fontSize:14}}>
            📊 Sumar {anDeLa}{anDeLa!==anPanaLa?` — ${anPanaLa}`:''}{nrAuto?` — ${nrAuto}`:''}
          </div>
          <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
            <Card title="Total cheltuieli" value={`${fmt(data.totalGeneral)} RON`} color="#c0392b"/>
            <Card title="Piese" value={`${fmt(data.totalPiese)} RON`}/>
            <Card title="Service" value={`${fmt(data.totalService)} RON`}/>
            <Card title="Vulcanizare" value={`${fmt(data.totalVulcanizare)} RON`}/>
            <Card title="Asigurări" value={`${fmt(data.totalAsigurari)} RON`}/>
            <Card title="Autorizări" value={`${fmt(data.totalAutorizari)} RON`}/>
            <Card title="Carburant" value={`${fmt(data.totalCarburant)} RON`}/>
            <Card title="Revizii" value={`${fmt(data.totalRevizii)} RON`}/>
          </div>
        </div>

        {/* Cheltuieli lunare */}
        {data.lunar && data.lunar.length > 0 && (
          <div style={{marginBottom:20,background:'white',borderRadius:8,border:'1px solid #dde4ec',overflow:'hidden'}}>
            <div style={{background:'#1a3a5c',color:'white',padding:'8px 14px',fontWeight:'bold',fontSize:13,
              display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <span>📅 Cheltuieli lunare</span>
              <div style={{display:'flex',gap:4}}>
                <button className="btn btn-sm" style={{background:'#217346',color:'white'}} onClick={()=>exportCSV(data.lunar,`cheltuieli_lunare`)}>📊 CSV</button>
                <button className="btn btn-sm" style={{background:'#555',color:'white'}} onClick={()=>printTable('Cheltuieli lunare',data.lunar)}>🖨️</button>
              </div>
            </div>
            <div style={{overflowX:'auto'}}>
              <table>
                <thead>
                  <tr>
                    <th>An</th><th>Luna</th><th style={{textAlign:'right'}}>Piese</th>
                    <th style={{textAlign:'right'}}>Service</th><th style={{textAlign:'right'}}>Vulcanizare</th>
                    <th style={{textAlign:'right'}}>Asigurări</th><th style={{textAlign:'right'}}>Autorizări</th>
                    <th style={{textAlign:'right'}}>Carburant</th><th style={{textAlign:'right'}}>Revizii</th>
                    <th style={{textAlign:'right'}}>TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  {data.lunar.map(r => {
                    const cheie = `${r.an}-${r.luna}`;
                    const deschis = !!randDeschis[cheie];
                    const linii = detaliiLuna[cheie];
                    return (
                      <React.Fragment key={cheie}>
                        <tr onClick={() => toggleLuna(r.an, r.luna)} style={{cursor:'pointer', background: deschis ? '#e8f0fe' : undefined}}>
                          <td><b>{deschis?'▼ ':'▶ '}{r.an}</b></td>
                          <td><b>{LUNI[parseInt(r.luna)-1]||r.luna}</b></td>
                          <td style={{textAlign:'right'}}>{fmt(r.piese)}</td>
                          <td style={{textAlign:'right'}}>{fmt(r.service)}</td>
                          <td style={{textAlign:'right'}}>{fmt(r.vulcanizare)}</td>
                          <td style={{textAlign:'right'}}>{fmt(r.asigurari)}</td>
                          <td style={{textAlign:'right'}}>{fmt(r.autorizari)}</td>
                          <td style={{textAlign:'right'}}>{fmt(r.carburant)}</td>
                          <td style={{textAlign:'right'}}>{fmt(r.revizii)}</td>
                          <td style={{textAlign:'right'}}><b style={{color:'#c0392b'}}>{fmt(r.total)}</b></td>
                        </tr>
                        {deschis && (
                          <tr>
                            <td colSpan={10} style={{padding:0}} onClick={e=>e.stopPropagation()}>
                              {!linii ? (
                                <div style={{padding:16}}><Spinner/></div>
                              ) : linii.length === 0 ? (
                                <div style={{padding:16,textAlign:'center',color:'#888',fontSize:12}}>Fără înregistrări detaliate în această lună</div>
                              ) : (
                                <div style={{margin:'8px 12px 16px',padding:14,background:'#f7f9ff',borderRadius:8,border:'1px solid #c0d0e8'}}>
                                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10,flexWrap:'wrap',gap:8}}>
                                    <div style={{fontWeight:'bold',color:'#1a3a5c',fontSize:13}}>
                                      📋 Detaliu — {LUNI[parseInt(r.luna)-1]||r.luna} {r.an}{nrAuto?` — ${nrAuto}`:''}
                                    </div>
                                    <div style={{display:'flex',gap:6}}>
                                      <button className="btn btn-sm" style={{background:'#217346',color:'white'}} onClick={()=>exportLuna(r.an,r.luna)}>📊 CSV</button>
                                      <button className="btn btn-sm" style={{background:'#555',color:'white'}} onClick={()=>printLuna(r.an,r.luna)}>🖨️ Print</button>
                                    </div>
                                  </div>
                                  <table style={{width:'100%'}}>
                                    <thead>
                                      <tr>
                                        <th style={{textAlign:'left'}}>Data</th>
                                        <th style={{textAlign:'left'}}>Categorie</th>
                                        <th style={{textAlign:'left'}}>Descriere</th>
                                        <th style={{textAlign:'right'}}>Valoare (RON)</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Object.entries(grupeazaPeVehicul(linii)).map(([veh, randuriVeh]) => {
                                        const subtotal = randuriVeh.reduce((s,x)=>s+parseFloat(x.valoare||0),0);
                                        return (
                                          <React.Fragment key={veh}>
                                            <tr style={{background:'#e0e9f5'}}>
                                              <td colSpan={4} style={{fontWeight:'bold',color:'#1a3a5c'}}>🚛 {veh}</td>
                                            </tr>
                                            {randuriVeh.map((x,i)=>(
                                              <tr key={i}>
                                                <td>{x.data}</td>
                                                <td>{x.categorie}</td>
                                                <td>{x.descriere}</td>
                                                <td style={{textAlign:'right',fontVariantNumeric:'tabular-nums'}}>{fmt(x.valoare)}</td>
                                              </tr>
                                            ))}
                                            <tr>
                                              <td colSpan={3} style={{textAlign:'right',fontWeight:'bold',color:'#555'}}>Subtotal {veh}:</td>
                                              <td style={{textAlign:'right',fontWeight:'bold',color:'#c0392b'}}>{fmt(subtotal)}</td>
                                            </tr>
                                          </React.Fragment>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Per vehicul */}
        {data.perVehicul && data.perVehicul.length > 0 && (
          <div style={{background:'white',borderRadius:8,border:'1px solid #dde4ec',overflow:'hidden'}}>
            <div style={{background:'#1a3a5c',color:'white',padding:'8px 14px',fontWeight:'bold',fontSize:13,
              display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <span>🚛 Cheltuieli per vehicul</span>
              <div style={{display:'flex',gap:4}}>
                <button className="btn btn-sm" style={{background:'#217346',color:'white'}} onClick={()=>exportCSV(data.perVehicul,'cheltuieli_per_vehicul')}>📊 CSV</button>
                <button className="btn btn-sm" style={{background:'#555',color:'white'}} onClick={()=>printTable('Cheltuieli per vehicul',data.perVehicul)}>🖨️</button>
              </div>
            </div>
            <div style={{overflowX:'auto'}}>
              <table>
                <thead>
                  <tr>
                    <th>Nr. Auto</th>
                    <th style={{textAlign:'right'}}>Piese</th><th style={{textAlign:'right'}}>Service</th>
                    <th style={{textAlign:'right'}}>Vulcanizare</th><th style={{textAlign:'right'}}>Asigurări</th>
                    <th style={{textAlign:'right'}}>Autorizări</th><th style={{textAlign:'right'}}>Carburant</th>
                    <th style={{textAlign:'right'}}>Revizii</th><th style={{textAlign:'right'}}>TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  {data.perVehicul.map(r => (
                    <tr key={r.nrAuto}>
                      <td><b>{r.nrAuto}</b></td>
                      <td style={{textAlign:'right'}}>{fmt(r.piese)}</td>
                      <td style={{textAlign:'right'}}>{fmt(r.service)}</td>
                      <td style={{textAlign:'right'}}>{fmt(r.vulcanizare)}</td>
                      <td style={{textAlign:'right'}}>{fmt(r.asigurari)}</td>
                      <td style={{textAlign:'right'}}>{fmt(r.autorizari)}</td>
                      <td style={{textAlign:'right'}}>{fmt(r.carburant)}</td>
                      <td style={{textAlign:'right'}}>{fmt(r.revizii)}</td>
                      <td style={{textAlign:'right'}}><b style={{color:'#c0392b'}}>{fmt(r.total)}</b></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </>}
    </div>
  );
}
